import React from "react";
import Youarehere from "../assets/you_are_here_result.png";
import graph from "../assets/graph-3.png";

const ProgressBar = ({ segments, locationPercentage }) => {
  if(locationPercentage<0)
    {
      locationPercentage=1;
    }
  let accumulatedPercentage = 0;
  let lamheight = 40;
  function getRandomIntInclusive(min, max) {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min + 1) + min); // The maximum is inclusive and the minimum is inclusive
  }
  return (
    <div className="mainProgressComponent p-3 rounded-20">
      <div className="mainProgressComponent m-auto w-8  mb-3 p-0">
        <img src={graph} width={1050} className="mx-auto d-block w-100" alt=""/>
        <div className="progress-bar">
          <div className="progress-container justify-content-center">
            {segments.map((segment, index) => (
              <div
                key={index}
                className="progress-segment "
                style={{
                  width: `${segment.percentage}%`,
                  backgroundColor: segment.color,
                }}
              ></div>
            ))}
          </div>
        </div>
        {/* <img src={number} width={920} className='img-fluid mx-auto d-block'/>  */}
        <div className="d-flex justify-content-start">
          {segments.map((segment, index) => {
            const maxPercentage = accumulatedPercentage + segment.percentage;
            accumulatedPercentage += segment.percentage;
            lamheight += 10;
            return (
              <div
                key={index}
                style={{
                  width: `${segment.percentage}%`,
                }}
              >
                {/* <div
                                // key={index}
                                className="segment-name text-black fw-500"
                                style={{ height: `${112}%` }}
                            > 
                             {segment.name} 
                               
                                 <div
                                    className="vertical-line"
                                    style={{
                                        backgroundColor: segment.color,
                                        // height: `${
                                        //     segment.percentage < 40
                                        //         ? segment.percentage + 65
                                        //         : maxPercentage + 10
                                        // }px`,
                                        height: `${getRandomIntInclusive(
                                            100,
                                            99,
                                        )}px`,
                                    }}
                                /> 
                             </div> */}

                <div className="percentage-labels">
                  <span className="min-percentage text-black fw-500">
                    {index == 0 && "0%"}
                  </span>
                  <span className="max-percentage text-black fw-500">
                    {maxPercentage}%
                  </span>
                </div>
              </div>
            );
          })}
        </div>

        {/* <div
          className="location-icon"
          style={{
            left: `${locationPercentage - 1.7}%`,
          }}
        > */}
        <img
          style={{
            left: `${locationPercentage - 1.7}%`,
          }}
          width={"30"}
          className="location-icon d-flex"
          src={Youarehere}
        alt="" />
        {/* </div> */}
      </div>
    </div>
  );
};

export default ProgressBar;
